import React from 'react';
import Checkbox from 'material-ui/Checkbox';
import FeedbackActions from '../actions/FeedbackActions';

function getCurrentState(props) {
    return {
        feedback: props.feedback,
        myKey: props.myKey
    }
}

class FeedbackItem extends React.Component {
    constructor(props) {
        super(props);

        this.state = getCurrentState(props);
    }
    componentWillReceiveProps(newProps) {
        this.state = getCurrentState(newProps);
    }
    render() {
        let feedback = this.state.feedback;
        let before = JSON.parse(feedback.contractor_set_data);
        let after = JSON.parse(feedback.super_contractor_set_data);

        let sectors = {
            1: 'Business',
            2: 'Education',
            3: 'ISP',
            4: 'CrawlBot',
            5: 'Public',
            6: 'Unknown',
            7: 'Complicated'
        }

        let nameClass = '';
        let telClass = '';
        let websiteClass = '';
        let sectorClass = '';

        if (before.name !== after.name) {
            nameClass = 'differentVal';
        }

        if (before.tel !== after.tel) {
            telClass = 'differentVal';
        }

        if (before.website !== after.website) {
            websiteClass = 'differentVal';
        }

        if (parseInt(before.sector) !== parseInt(after.sector)) {
            sectorClass = 'differentVal';
        }

        return (
            <div className="feedbackItem">
                <div className="row">
                    <div className="col-md-5">
                        <table className="feedbackItemTable">
                            <thead>
                            <tr>
                                <th style={{width: 100}}>Field</th>
                                <th style={{width: 180}}>Before</th>
                                <th style={{width: 180}}>After</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Name</td>
                                <td className={nameClass}>{before.name}</td>
                                <td className={nameClass}>{after.name}</td>
                            </tr>
                            <tr>
                                <td>Tel</td>
                                <td className={telClass}>{before.tel}</td>
                                <td className={telClass}>{after.tel}</td>
                            </tr>
                            <tr>
                                <td>Website</td>
                                <td className={websiteClass}>{before.website}</td>
                                <td className={websiteClass}>{after.website}</td>
                            </tr>
                            <tr>
                                <td>Sector</td>
                                <td className={sectorClass}>{sectors[parseInt(before.sector)]}</td>
                                <td className={sectorClass}>{sectors[parseInt(after.sector)]}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="col-md-7">
                        <strong>Comments</strong>

                        <div className="commentsBox">
                            {feedback.comments}
                        </div>

                        <div className="clr"></div>
                        <br/>

                        <Checkbox
                            label="Acknowledged"
                            onCheck={(event, isChecked) => this._acknowledge(isChecked)}
                        />
                    </div>
                </div>
            </div>
        )
    }
    _acknowledge(isChecked) {
        if (isChecked) {
            FeedbackActions.acknowledgeItem(this.state.myKey);
        }
    }
}

export default FeedbackItem;



// WEBPACK FOOTER //
// ./resources/assets/js/data-feed/components/FeedbackItem.react.js